import React, { useRef } from 'react';
import GxForm from '../../gx/GxForm';
import { useTranslation } from '../../hx/useTranslation';
import { useNav } from '../../hx/useNav';
import CxHidden from '../../cx/CxHidden';
import CxInput from '../../cx/CxInput';
import CxState from '../../cx/CxState';
import CxCombo from '../../cx/CxCombo';
import CxSnackbar from '../../cx/CxSnackbar';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import { StoreSettCusDoc } from "../../gx/GxStore";
import { isApp } from '../../gx/GxStore';
import { useSessionStorage } from '../../hx/useSessionStorage';
import CxTextEditor from '../../cx/CxTextEditor'; // CxTextEditor
import { plugin_submenu } from '../../cx/CxTextEditorSubmenuCusDoc';
import { fontSize, fontColor, hiliteColor, list } from 'suneditor/src/plugins';


const MxSettCusDocForm = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navBack }] = useNav();

  let r_form = React.useRef(null);

  const rf_boNotifyPending = React.useRef(null);
  const rf_txModule = React.useRef(null);
  const rf_txContent = React.useRef(null);

  const r_snack_error = React.useRef(null);
  
  const [storeSettCusDoc, setStoreSettCusDoc] = useSessionStorage('StoreSettCusDoc', StoreSettCusDoc);

  const formLoad = async (data) => {
    if (data===null) { //nuevo registro
    }
  }
  const formSave = async (lastSaveRv) => {
    if (lastSaveRv.theStatus==='error') {
    } else {
      storeSettCusDoc.itDoc = lastSaveRv.theValue;
      Promise.all([setStoreSettCusDoc(storeSettCusDoc)]).then((result) => {
        navBack();
      });
    }
  }
  const formDelete = async (rv) => {
  }
  
  const checkIfPatientTextInClientFile = () => {
    if (rf_txModule.current.getKey()==='C' && rf_txContent.current.getVal().includes('txAnimal')) {
      r_snack_error.current.setValAndOpen(trans('msg.for_this_content_select_x_module', 'field.patient'));
      return false;
    } else {
      return true; // puede guardar
    }
  }

  return (
    <div>
      <GxForm 
        moduleName={`${trans('field.customization')} - ${trans('field.doc')}`}
        xref={r_form}
        url="sett/cus_doc" 
        filterIdField='itDoc'
        filterIdValue={storeSettCusDoc.itDoc} 
        onFormLoad={formLoad} 
        onFormSave={formSave} 
        saveAndExit
        onFormDelete={formDelete} 
        onFormBeforeSave={checkIfPatientTextInClientFile}
        >
        <CxHidden xref={useRef(null)} dbfield="t_doc.itDoc" value={storeSettCusDoc.itDoc || ''} />
        <CxInput xref={useRef(null)} label={`${trans('field.doc')}`} dbfield="t_doc.txTypeDoc" maxLength={100} required />
        
        <CxCombo xref={rf_txModule}
          label={`${trans('field.module')}`}
          dbfield='t_doc_tpl.txModule'
          list={
            (isApp('vett') || isApp('spaw')) ? 
              [ { id: 'C', type: trans('field.client') }, { id: 'A', type: trans('field.patient') } ]
            :
              [ { id: 'C', type: trans('field.client') } ]
          }
          required
          autoSelectFirst
        />
        <CxState mode='checkbox' xref={rf_boNotifyPending} dbfield="t_doc.boNotifyPending" label={trans('field.sett_notify_pending')} />

        <CxInput xref={useRef(null)} label={`${trans('field.doc_title')}`} dbfield="t_doc_tpl.txTitle" maxLength={50} />
        <CxInput xref={useRef(null)} label={`${trans('field.doc_subtitle')}`} dbfield="t_doc_tpl.txSubtitle" maxLength={50} />
        <CxState mode='checkbox' xref={useRef(null)} dbfield="t_doc_tpl.boAddHeader" label={trans('field.layout_header')} />
        <CxState mode='checkbox' xref={useRef(null)} dbfield="t_doc_tpl.boAddFooter" label={trans('field.layout_footer')} />
        <CxTextEditor
          xref={rf_txContent}
          label={trans('field.content')}
          dbfield="t_doc_tpl.txContent"
          minRows={20}
          plugins={[plugin_submenu, fontSize, fontColor, hiliteColor, list]}
          buttonList={[
            ['undo', 'redo', 'fontSize', 'fontColor', 'hiliteColor'],
            ['bold', 'underline', 'italic', 'list', 'removeFormat'],
            [
              {
                name: 'custom_plugin_submenu',
                dataDisplay: 'submenu',
                title: trans('field.placeholders'),
                buttonClass: '',
                //innerHTML: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg>'
                innerHTML: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M1.728 20.992q-0.416 1.6 0.416 3.008 0.832 1.44 2.432 1.856t3.040-0.384q0.832-0.48 2.56-1.92t3.168-2.912q-0.608 2.016-0.96 4.192t-0.384 3.168q0 1.664 1.184 2.848t2.816 1.152 2.816-1.152 1.184-2.848q0-0.96-0.384-3.168t-0.928-4.192q1.44 1.504 3.168 2.944t2.528 1.888q1.44 0.832 3.040 0.384t2.432-1.856 0.416-3.008-1.888-2.464q-0.864-0.48-2.944-1.248t-4.064-1.28q2.016-0.512 4.096-1.28t2.912-1.248q1.44-0.832 1.888-2.432t-0.416-3.040q-0.832-1.44-2.432-1.856t-3.040 0.384q-0.832 0.512-2.528 1.92t-3.168 2.912q0.576-1.984 0.928-4.192t0.384-3.168q0-1.632-1.184-2.816t-2.816-1.184-2.816 1.184-1.184 2.816q0 0.992 0.384 3.168t0.96 4.192q-1.44-1.472-3.168-2.88t-2.56-1.952q-1.44-0.8-3.040-0.384t-2.432 1.856-0.416 3.040 1.888 2.432q0.832 0.48 2.912 1.248t4.128 1.28q-2.016 0.512-4.096 1.28t-2.944 1.248q-1.44 0.832-1.888 2.464z"/></svg>'
              }
            ]
          ]}
        />

      </GxForm>

      <CxSnackbar xref={r_snack_error} severity="error" />


    </div>
  );

}

export default MxSettCusDocForm;
